import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchTransportList = createAsyncThunk("fetchTransportList", async ({filters }) => {
    const formatDate = (date) => (date && date.isValid && date.isValid() ? date.format("YYYY-MM-DD") : "");
    
    const params = new URLSearchParams({
        keyword: filters?.keyword ?? "",
        statusId: filters?.status_id ?? "",
        start_date: filters?.dateRange && filters.dateRange[0] ? formatDate(filters.dateRange[0]) : "",
        end_date: filters?.dateRange && filters.dateRange[1] ? formatDate(filters.dateRange[1]) : "",
    });
    
    try {
        const response = await axiosHttp.get(`requests/transport?${params}`);
    
        return response.data;
    } catch (error) {
        console.error("Transport API Error:", error);
        throw error;
    }
});

const TransportListSlice = createSlice({
    name: "TransportListSlice",
    initialState: {
        isLoading: false,
        data: null,
        error: null,
        page: 1,
        total: 0,
    },

    extraReducers: (builder) => {
        builder.addCase(fetchTransportList.pending, (state) => {
            state.isLoading = true;
        });

        builder.addCase(fetchTransportList.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
            state.page = action.payload.page || 1;
            state.total = action.payload.total || (action.payload.data ? action.payload.data.length : 0);
        });
        builder.addCase(fetchTransportList.rejected, (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        });
    },
});

export default TransportListSlice.reducer;
